/**
 * The frontend's entire knowledge of what a feature needs.
 *
 * Two kinds, kept deliberately separate rather than as one union — they answer
 * different questions and have different shapes. Neither knows about
 * subscription tiers: "unlimited tier" arrives from `GET /credits` as
 * `total: "unlimited"`, so tiers stay a backend concern.
 *
 * A definition carries the feature's name, never its denial copy. What to say
 * when access is refused depends on the *reason* — out of credits, not logged
 * in, no club imported — and one feature can be refused for several of them, so
 * the message belongs with the reason.
 */
export const CREDIT_FEATURES = {
    "solve-sbc-club": {
        label: "Solving an SBC with your club",
        action: "solve SBCs with your own players",
    },
    "build-squad-club": {
        label: "Building a squad with your club",
        action: "build squads with your own players",
    },
    "squad-recommendations-club": {
        label: "Update recommendations for your active squad",
        action: "get upgrades for your squad",
    },
    "evo-chains-club": {
        label: "Best evolution chain for one of your evolution players with your own evolutions",
        action: "see evolution chains for your evolution players",
    },
    "gallery-solutions-built": {
        label: "Building Gallery solutions with your club",
        action: "build Gallery solutions with your own players",
    },
    "gallery-level-plan-built": {
        label: "Building a Gallery level plan",
        action: "plan your Gallery level with your collected players",
    },
};
export const CLUB_IMPORT_FEATURES = {
    "see-own-players": {
        label: "Your own players",
        action: "browse the players you own",
    },
    "see-own-evo-players": {
        label: "Your evolved players",
        action: "see your evolved players",
    },
    "see-active-squad": {
        label: "Your active squad",
        action: "see your active squad",
    },
    "club-player-filters": {
        label: "Filtering by your club",
        action: "filter by the players you own",
    },
    "include-loan-players": {
        label: "Loan players",
        action: "use your loan players",
    },
};
export const creditFeatureLabel = (featureId) => CREDIT_FEATURES[featureId].label;
export const clubImportFeatureLabel = (featureId) => CLUB_IMPORT_FEATURES[featureId].label;
/**
 * The action phrase for either kind of feature — the club-import gate can be
 * raised by both, and its copy reads the same either way.
 */
export const featureActionPhrase = (featureId) => featureId in CREDIT_FEATURES
    ? CREDIT_FEATURES[featureId].action
    : CLUB_IMPORT_FEATURES[featureId].action;
//# sourceMappingURL=featureCatalog.js.map